var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"Shipment Timeline","breadcrumb":"Dashboard > Bookings & Shipments  > Trackings"}}),_c('div',{staticClass:"bg-white py-3"},[_c('shipment-table'),_c('shipment-timeline'),_c('TimelineShippingDetails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }